import styled from "styled-components";

export const Title = styled.div`
  color: var(--color-gray-950, #19191b);
  font-size: var(--font-size-xl, 24px);
  font-weight: 900;
  line-height: var(--font-line-height-xl, 36px);
`;

export const Subtitle = styled.div`
  color: var(--color-gray-900, #2f2f32);
  font-size: var(--font-size-sm, 14px);
  font-weight: 400;
  line-height: var(--font-line-height-md, 24px);
`;
